<script setup lang="ts">
interface CheckboxProps {
  modelValue?: boolean
  error?: string
  disabled?: boolean
  description?: string
  name?: string
  isAllSelected: boolean
  isAll?: boolean
  highlight?: boolean
}
interface IEmits {
  (event: 'update:modelValue', value: boolean): void
}

const props = defineProps<CheckboxProps>()

const emits = defineEmits<IEmits>()
const value = useVModel(props, 'modelValue', emits)

const toggle = () => {
  if (unref(props.disabled))
    return
  value.value = !value.value
}
</script>

<template>
  <span
    role="checkbox"
    font-inter
    :aria-checked="highlight || value && !isAllSelected || isAll && value "
    :aria-disabled="disabled"
    :class="[$style.checkbox, $attrs.class]"
    tabindex="0"
    v-bind="$attrs"
    @click.stop="toggle"
  >
    <span class="flex items-center gap-1">
      <slot :is-checked="highlight || value && !isAllSelected || isAll && value " />
    </span>
  </span>
</template>

<style lang="scss" module>
.checkbox {
  @apply
  capitalize
  hover:bg-softGray hover:text-darkerGray bg-[#F6F6FF] text-[#A8B6D8]
  justify-center flex items-center rounded-full
  text-xs leading-4.5 cursor-pointer select-none min-w-3.5 min-h-4.5;
  font-weight: bold !important;
  padding: 7px 12px;
  &[aria-checked='true'] {
    @apply bg-black text-white;
  }
}
</style>
